import { useEffect, useRef, useState } from 'react';

export interface Change { delta: number; id: number }

/**
 * The last change of `value` (how much, and an id that is new for every change), kept for `ms` and then null.
 * Nothing on the first render: only changes that happen while the person is looking.
 */
export function useChange(value: number, ms: number): Change | null {
  const [change, setChange] = useState<Change | null>(null);
  const prev = useRef(value);
  const seq = useRef(0);
  useEffect(() => {
    const delta = value - prev.current;
    prev.current = value;
    if (!delta) return;
    setChange({ delta, id: ++seq.current });
    const t = window.setTimeout(() => setChange(null), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return change;
}
